import videojs from 'video.js';
import 'videojs-contrib-ads';
import 'videojs-ima';

class VideoPlayer {
  constructor(options) {
    this.options = options || {};
    this.container = document.getElementById('video');
    this.video = this.container.querySelector('video');
    this.videoId = this.container.getAttribute('data-videoid');
    this.poster = this.container.getAttribute('data-poster') ? this.container.getAttribute('data-poster') : 'https://i.ytimg.com/vi/' + this.videoId + '/hqdefault.jpg';
    this.mode = this.container.getAttribute('data-mode');

    if (!window.google || !window.google.ima) {
      if (this.mode === 'inread') {
        return;
      }
      this.display(0);
      return;
    }

    if (this.mode === 'inread') {
      this.frame = parent.document.getElementById('inread');
      this.started = false;
      this.adsready = false;
      this.addScrollEvent();
      this.poster = '';
    }

    this.player = videojs(this.video, {
      autoplay: false,
      poster: this.poster,
      contribAdsSettings: {
        prerollTimeout: 10000,
        timeout: 10000
      }
    });

    this.parent = this.container.querySelector('.video-element');
    this.parent.style.display = 'none';
    this.run();

  }

  run() {
    this.player.ima(this.getAdOptions());

    if (this.mode === 'inread') {
      this.initAds();
    } else {
      this.event = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Android/i) ? 'touchend' : 'click';
      this.container.addEventListener(this.event, () => {
        this.initAds();
      });
    }

    this.player.on('adserror', () => {
      if (this.mode === 'inread') {
        this.frame.style.display = 'none';
        return;
      }
      this.parent.style.display = 'block';
      this.player.dispose();
      this.display(0);
    });
    this.player.on('adsready', () => {
      this.adsready = true;
      this.parent.style.display = 'block';
      if (this.mode === 'inread') {
        this.frame.style.display = 'block';
        if (!this.started && this.isVisible()) {
          this.started = true;
          this.player.play();
        }
      }
      this.player.ima.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, () => {
        if (this.mode === 'inread') {
          this.player.pause();
          this.player.dispose();
          this.reload();
          return;
        }
        this.player.dispose();
        this.display(1);
      });
    });
  }

  initAds() {
    this.player.ima.initializeAdDisplayContainer();
    this.container.removeEventListener(this.event, this.initAds);
  }

  display(autoplay) {
    var player = new YT.Player(this.container, {
      height: 315,
      width: 560,
      videoId: this.videoId,
      playerVars: {
        autoplay: autoplay,
        modestbranding: 1,
        playsinline: 1
      }
    });
  }

  getAdTagUrl() {
    var url = window.adTagUrl;
    if (!url) {
      url = this.mode === 'inread' ? parent.inread.adTagUrl : parent.adTagUrl;
      if (parent.googletag && parent.googletag.pubads) {
        url += '&cust_params=';
        url += 'site%3D' + parent.googletag.pubads().getTargeting('site');
        url += '%26pageSection%3D' + parent.googletag.pubads().getTargeting('pageSection');
        url += '%26pageCategory%3D' + parent.googletag.pubads().getTargeting('pageCategory');
        url += '%26pageType%3D' + parent.googletag.pubads().getTargeting('pageType');
        url += '%26storyId%3D' + parent.googletag.pubads().getTargeting('storyid');
      }
    }
    return url;
  }

  getAdOptions() {
    var options = {
      id: this.videoId,
      adTagUrl: this.getAdTagUrl(),
      nonLinearWidth: 500,
      nonLinearHeight: 234,
      adLabel: 'Διαφήμιση'
    }
    return options;
  }

  addScrollEvent() {
    parent.addEventListener('scroll', (event) => {
      if (this.started || !this.adsready) {
        return;
      }
      if (this.isVisible()) {
        this.started = true;
        this.player.play();
      }
    }, false);
  }


  isVisible() {
    let rect = this.frame.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= (parent.innerHeight || parent.documentElement.clientHeight);
  }

  reload() {
    this.container.innerHTML = '<video class="video-element video-js vjs-fluid vjs-16-9" playsinline webkit-playsinline preload="auto" width="560" height="315"><source src="https://play.bbend.com/preroll/v15/video/blank.mp4" type="video/mp4" /></video>';
    this.video = this.container.querySelector('video');
    this.player = videojs(this.video, {
      autoplay: false,
      poster: this.poster,
      contribAdsSettings: {
        prerollTimeout: 10000,
        timeout: 10000
      }
    });
    this.run();
  }

}

export {
  VideoPlayer as
  default
};
